import { bootAfterHandoffGate, isStandaloneSharePath } from "../lib/desktopHandoff";
import "../app/globals.css";
import { startRouteModule } from "./earlyRoutes";

/**
 * The app entry is deliberately almost empty. Everything real lives in
 * ./boot.tsx behind a dynamic import, because a browser page that is about to
 * hand itself off to the desktop app must not load the app at all: the module
 * bodies of the store, the Convex client and React run on import, so an early
 * `return` in a heavyweight entry would still have paid for a socket, an
 * IndexedDB hydration and a render nobody sees.
 *
 * That decision was already made, inlined in index.html's <head>
 * (plugins/handoffBoot.ts) — this only honors it, including the held case: a
 * background tab that will hand off once looked at boots only if the gate
 * decides against the handoff.
 *
 * globals.css stays imported here so the stylesheet remains a plain <link> in
 * the built HTML, fetched in parallel on every load.
 */
bootAfterHandoffGate(() => {
  // Share pages boot standalone: they hydrate server-rendered markup and never
  // need the store, the inbox, or auth. Everything else is the app.
  if (isStandaloneSharePath(window.location.pathname)) return void import("./shareBoot");
  // The route's own modules load beside boot's, not after the shell reaches it.
  startRouteModule(window.location.pathname);
  void import("./boot");
});
